<template>
<div class="page_set page">
	<!-- 绑卡 -->
	<van-tabs v-model="type" swipe-threshold="6">
        <van-tab title="平台充值卡" :name="1"></van-tab>
        <van-tab title="园区充值卡" :name="2"></van-tab>
    </van-tabs>
    <div class="list erji bangka">
        <div class="item">
            <div class="name">请输入卡号：</div>
            <div class="bianhao">
                <van-field v-model="cardNum" placeholder="请输入卡号" />
            </div>
        </div>
        <div class="item">
            <div class="name">请输入密码：</div>
            <div class="code">
                <van-field v-model="code" placeholder="请输入密码" />
            </div>
        </div>
    </div>
    <div class="big_btn btn" @click="tijiao">确定</div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "set-card",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            isClient: false, //是否在iOSAndroid客户端内显示
			token: null,
			cardNum: null ,// 卡号
			code: null, // 验证码
			type: 1 // 充值卡类型 1 平台卡 2园区卡
        };
    },
    created: function () {

    },
    mounted: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            this.setClientInfo()
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.setClientInfo()
                responseCallback('refresh success')
            })
            //注册方法，右上角设置按钮点击事件
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var memberParams = {
                    'data': {
                        'forceLogin': 1,
                    }
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {

                })
                responseCallback('success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
        setClientInfo() {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '绑定新卡',
                    // 'hiddenBack': true,
                    // 'rightStyle': 'setup'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
		},
		// 提交
		tijiao(){
			console.log('type====',this.type)
			if(!this.cardNum){
				this.$toast('请输入卡号');
				return
            }
            if(!this.code){
				this.$toast('请输入密码');
				return
            }
            var params = {
                token: this.token,
                number: this.cardNum,
                password: this.code
			}
			
			if(this.type == 1){
				// 绑平台卡
				this.$api.my.bindCard(params).then(res => {
					if (res.code == 200) {
						this.$router.back()
					} else {
						this.$toast(res.message)
					}
				})
			}else if(this.type == 2){
				// 绑园区卡
				this.$api.my.bindParkCard(params).then(res => {
					if (res.code == 200) {
						this.$router.back()
					} else {
						this.$toast(res.message)
					}
				})
			}
            
		}

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
